import styled from 'styled-components';
import { Sizes } from '../../utils/sizes';
import { Colors } from '../../utils/colors';

export const CheckoutContainerStyle = styled.section`
  width: 100%;
  min-height: 100vh;
  background-image: url('imageSection1.webp');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 50px 20px;
  position: relative;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 30px 16px;
  }

  @media (max-width: 480px) {
    padding: 20px 12px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(20, 20, 20, 0.9) 0%, rgba(20, 20, 20, 0.7) 50%);
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const CheckoutContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    max-width: 100%;
    padding: 0;
  }
`;

export const CheckoutHeader = styled.header`
  margin-bottom: 40px;
  text-align: center;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }

  & h1 {
    color: ${Colors.yellow};
    font-size: 48px;
    margin-bottom: 10px;
    font-weight: 700;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 32px;
      margin-bottom: 8px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
      margin-bottom: 6px;
    }
  }

  & p {
    color: ${Colors.gold};
    font-size: 16px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 14px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
    }
  }
`;

export const CheckoutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
  align-items: start;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    gap: 16px;
  }
`;

export const CheckoutSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

// Resumo do pedido: gruda ao rolar (só no desktop). No mobile fica no fluxo
// normal para não sobrepor o conteúdo empilhado.
export const StickySummary = styled.div`
  position: sticky;
  top: 20px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    position: static;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: 2px solid ${Colors.yellow};
  color: ${Colors.yellow};
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  transition: all 0.3s ease;
  margin-top: 20px;
  align-self: flex-start;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    width: 100%;
    align-self: center;
  }

  @media (max-width: 480px) {
    padding: 8px 16px;
    font-size: 12px;
    margin-top: 12px;
  }

  &:hover {
    background: ${Colors.yellow};
    color: ${Colors.dark};
  }
`;

export const StatusMessage = styled.div`
  /* Toast FIXO no topo-centro — visível mesmo com modal aberto, e não empurra
     o layout (antes ficava "abaixo do modal"). Entra com fade + slide suave. */
  position: fixed;
  top: 18px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1200;
  width: calc(100% - 32px);
  max-width: 460px;
  padding: 14px 18px;
  border-radius: 12px;
  font-size: 14px;
  text-align: center;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(4px);
  animation: statusToastIn 300ms cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes statusToastIn {
    from {
      opacity: 0;
      transform: translate(-50%, -14px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  @media (max-width: 480px) {
    padding: 11px 14px;
    font-size: 12px;
  }

  background: ${(props) => {
    switch (props.type) {
      case 'success':
        return 'rgba(34, 197, 94, 0.1)';
      case 'error':
        return 'rgba(239, 68, 68, 0.1)';
      case 'info':
      default:
        return 'rgba(59, 130, 246, 0.1)';
    }
  }};
  border: 1px solid ${(props) => {
    switch (props.type) {
      case 'success':
        return '#22c55e';
      case 'error':
        return '#ef4444';
      case 'info':
      default:
        return '#3b82f6';
    }
  }};
  color: ${(props) => {
    switch (props.type) {
      case 'success':
        return '#22c55e';
      case 'error':
        return '#ef4444';
      case 'info':
      default:
        return '#3b82f6';
    }
  }};
`;

export const GoToPaymentButton = styled.button`
  display: none;
  width: 100%;
  background: linear-gradient(135deg, ${Colors.yellow} 0%, #ffc107 100%);
  color: ${Colors.dark};
  border: none;
  padding: 14px 16px;
  border-radius: 8px;
  font-weight: 900;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 16px rgba(255, 193, 0, 0.35);
  margin-top: 16px;

  @media (max-width: 480px) {
    display: block;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255, 193, 0, 0.5);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CartItemsGrid = styled.div`
  width: 100%;
  margin-top: 20px;

  & .grid-title {
    color: ${Colors.yellow};
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.3px;

    @media (max-width: 480px) {
      font-size: 12px;
      margin-bottom: 10px;
    }
  }

  & .items-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 14px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
      gap: 12px;
    }

    @media (max-width: 480px) {
      grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
      gap: 10px;
    }
  }

  & .item-card {
    background: linear-gradient(135deg, rgba(255, 193, 13, 0.08) 0%, rgba(255, 193, 13, 0.04) 100%);
    border: 1px solid rgba(255, 193, 0, 0.25);
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    &:hover {
      border-color: rgba(255, 193, 0, 0.5);
      background: linear-gradient(135deg, rgba(255, 193, 13, 0.12) 0%, rgba(255, 193, 13, 0.08) 100%);
      transform: translateY(-4px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
    }

    & .item-image {
      width: 100%;
      aspect-ratio: 3 / 4;
      overflow: hidden;
      border-bottom: 1px solid rgba(255, 193, 0, 0.15);

      & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
      }
    }

    & .item-info {
      padding: 12px;
      display: flex;
      flex-direction: column;
      flex: 1;

      @media (max-width: 480px) {
        padding: 8px;
      }
    }

    & .item-name {
      color: ${Colors.white};
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 8px;
      line-height: 1.3;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;

      @media (max-width: 480px) {
        font-size: 10px;
        margin-bottom: 4px;
      }
    }

    & .item-price {
      color: ${Colors.yellow};
      font-size: 14px;
      font-weight: 800;
      margin-top: auto;
    }
  }
`;

export const PromotionalBox = styled.div`
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.12) 0%, rgba(255, 193, 13, 0.08) 100%);
  border: 2px solid ${Colors.gold};
  border-radius: 12px;
  padding: 24px;
  position: relative;
  overflow: hidden;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 18px;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    padding: 14px;
    border-radius: 8px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, ${Colors.gold}, transparent);
  }

  & .promo-label {
    display: inline-block;
    background: ${Colors.yellow};
    color: ${Colors.dark};
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: 16px;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 8px rgba(255, 193, 0, 0.3);
  }

  & .promo-title {
    color: ${Colors.yellow};
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  & .promo-description {
    color: ${Colors.textSecondary};
    font-size: 13px;
    margin-bottom: 15px;
    line-height: 1.5;
  }

  & .promo-swap-title {
    color: ${Colors.yellow};
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 10px;
    letter-spacing: -0.5px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 20px;
      margin-bottom: 8px;
    }

    @media (max-width: 480px) {
      font-size: 16px;
      margin-bottom: 6px;
    }
  }

  & .promo-swap-subtitle {
    color: #e5e5e5;
    font-size: 14px;
    margin-bottom: 20px;
    line-height: 1.6;
    font-weight: 400;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 12px;
      margin-bottom: 14px;
      line-height: 1.5;
    }

    @media (max-width: 480px) {
      font-size: 11px;
      margin-bottom: 10px;
    }
  }

  & .swap-row {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      flex-direction: column;
      gap: 12px;
    }

    @media (max-width: 480px) {
      gap: 10px;
      margin-bottom: 14px;
    }
  }

  & .choice {
    flex: 1 1 0;
    background: linear-gradient(135deg, rgba(40,40,40,0.8) 0%, rgba(30,30,30,0.8) 100%);
    border: 1.5px solid rgba(255, 193, 0, 0.25);
    border-radius: 10px;
    padding: 16px;
    text-align: left;
    color: ${Colors.white};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 150px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    position: relative;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 12px;
      min-height: 120px;
    }

    @media (max-width: 480px) {
      padding: 10px;
      min-height: 100px;
    }

    &:hover {
      border-color: rgba(255, 193, 0, 0.45);
      background: linear-gradient(135deg, rgba(50,50,50,0.9) 0%, rgba(40,40,40,0.9) 100%);
      transform: translateY(-2px);
    }
  }

  & .choice .choice-title {
    font-size: 11px;
    color: ${Colors.textSecondary};
    text-transform: uppercase;
    margin-bottom: 8px;
    font-weight: 800;
    letter-spacing: 0.3px;

    @media (max-width: 480px) {
      font-size: 9px;
      margin-bottom: 4px;
    }
  }

  & .choice .choice-price {
    font-size: 26px;
    color: ${Colors.yellow};
    font-weight: 900;
    margin-bottom: 4px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      font-size: 20px;
    }

    @media (max-width: 480px) {
      font-size: 16px;
      margin-bottom: 2px;
    }
  }

  & .choice .choice-details {
    font-size: 12px;
    color: ${Colors.textSecondary};

    @media (max-width: 480px) {
      font-size: 10px;
    }
  }

  & .arrow-button {
    width: 52px;
    height: 52px;
    border-radius: 26px;
    background: ${Colors.yellow};
    color: ${Colors.dark};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 20px;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(255, 193, 0, 0.4);
    align-self: center;
    flex: 0 0 52px;
    margin: 0 8px;
    transition: all 0.3s ease;
    border: none;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      width: 44px;
      height: 44px;
      font-size: 16px;
      border-radius: 22px;
      margin: 0 6px;
    }

    @media (max-width: 480px) {
      width: 40px;
      height: 40px;
      font-size: 14px;
      border-radius: 20px;
      margin: 0 4px;
    }

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 8px 24px rgba(255, 193, 0, 0.6);
    }

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      margin: 8px 0;
    }
  }

  display: flex;
  flex-direction: column;
  align-items: stretch;

  & .promo-summary {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    padding: 14px 16px;
    background: linear-gradient(90deg, rgba(16,185,129,0.08) 0%, rgba(16,185,129,0.04) 100%);
    border: 1px solid rgba(16,185,129,0.2);
    border-radius: 8px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      padding: 10px 12px;
      margin-bottom: 12px;
    }

    @media (max-width: 480px) {
      padding: 8px 10px;
      gap: 6px;
    }
  }

  & .summary-badge {
    background: rgba(16,185,129,0.15);
    border: 1px solid rgba(16,185,129,0.35);
    color: #10b981;
    padding: 8px 14px;
    border-radius: 6px;
    font-weight: 800;
    font-size: 12px;
    white-space: nowrap;
    letter-spacing: 0.2px;

    @media (max-width: 480px) {
      font-size: 10px;
      padding: 6px 10px;
    }
  }

  & .promo-cta {
    width: 100%;
    background: linear-gradient(135deg, ${Colors.yellow} 0%, #ffc107 100%);
    color: ${Colors.dark};
    border: none;
    padding: 16px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 15px;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 6px 16px rgba(255, 193, 0, 0.35);

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 12px;
      font-size: 13px;
      letter-spacing: 0.4px;
    }

    @media (max-width: 480px) {
      padding: 10px;
      font-size: 11px;
      letter-spacing: 0.2px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(255, 193, 0, 0.5);
    }

    &:active {
      transform: translateY(0);
    }
  }

  & .promo-footer-note {
    font-size: 12px;
    color: ${Colors.textSecondary};
    margin-top: 12px;
    text-align: center;

    @media (max-width: 480px) {
      font-size: 10px;
      margin-top: 8px;
    }
  }

  & .bump-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 14px;

    @media (max-width: 480px) {
      gap: 12px;
      margin-bottom: 10px;
    }

    & .bump-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 2px solid ${Colors.gold};
      background: rgba(255, 215, 0, 0.06);
      color: ${Colors.yellow};
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      flex-shrink: 0;

      @media (max-width: 480px) {
        width: 48px;
        height: 48px;
        font-size: 20px;
      }
    }

    & .bump-info {
      flex: 1;

      & .bump-title {
        font-size: 17px;
        font-weight: 700;
        color: ${Colors.white};
        margin-bottom: 2px;

        @media (max-width: 480px) {
          font-size: 14px;
        }
      }

      & .bump-price {
        font-size: 24px;
        font-weight: 900;
        color: ${Colors.yellow};
        margin-bottom: 4px;

        @media (max-width: 480px) {
          font-size: 20px;
        }
      }

      & .bump-desc {
        font-size: 12px;
        color: ${Colors.textSecondary};
        line-height: 1.4;

        @media (max-width: 480px) {
          font-size: 11px;
        }
      }
    }
  }

  & .bump-features {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 14px;

    & .bump-feature {
      font-size: 13px;
      color: ${Colors.gold};
      font-weight: 500;

      @media (max-width: 480px) {
        font-size: 11px;
      }
    }
  }

  & .promo-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 15px;
    padding: 12px;
    background: rgba(20, 20, 20, 0.5);
    border-radius: 6px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      gap: 10px;
      padding: 10px;
    }

    @media (max-width: 480px) {
      gap: 8px;
      padding: 8px;
    }

    & .detail-item {
      text-align: center;

      & .label {
        color: ${Colors.textSecondary};
        font-size: 11px;
        text-transform: uppercase;
        margin-bottom: 4px;

        @media (max-width: 480px) {
          font-size: 9px;
          margin-bottom: 2px;
        }
      }

      & .value {
        color: ${Colors.yellow};
        font-size: 16px;
        font-weight: bold;

        @media (max-width: ${Sizes.mediaQueryBreak1}) {
          font-size: 14px;
        }

        @media (max-width: 480px) {
          font-size: 12px;
        }
      }
    }
  }

  & .promo-button {
    width: 100%;
    background: ${Colors.yellow};
    color: ${Colors.dark};
    border: none;
    padding: 12px;
    border-radius: 6px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      padding: 10px;
      font-size: 12px;
    }

    @media (max-width: 480px) {
      padding: 8px;
      font-size: 10px;
      letter-spacing: 0.2px;
    }

    &:hover {
      background: ${Colors.gold};
      transform: scale(1.02);
    }
  }

  & .promo-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    @media (max-width: ${Sizes.mediaQueryBreak1}) {
      grid-template-columns: 1fr;
    }

    & .promo-button-primary {
      background: ${Colors.yellow};
      color: ${Colors.dark};
      border: none;
      padding: 12px;
      border-radius: 6px;
      font-weight: bold;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      @media (max-width: 480px) {
        padding: 10px;
        font-size: 11px;
      }

      &:hover {
        background: ${Colors.gold};
        transform: scale(1.02);
      }
    }

    & .promo-button-secondary {
      background: transparent;
      border: 2px solid ${Colors.yellow};
      color: ${Colors.yellow};
      padding: 10px;
      border-radius: 6px;
      font-weight: bold;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      @media (max-width: 480px) {
        padding: 8px;
        font-size: 11px;
      }

      &:hover {
        background: ${Colors.yellow};
        color: ${Colors.dark};
      }
    }
  }
`;

export const AccountPromptBox = styled.div`
  background: rgba(20, 20, 20, 0.7);
  border: 2px solid ${Colors.yellow};
  border-radius: 12px;
  padding: 28px 24px;
  margin-bottom: 24px;
  color: ${Colors.white};
  /* Entrada suave (antes o card "pulava" na tela ao confirmar o pagamento). */
  animation: accountBoxIn 360ms cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes accountBoxIn {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  & h3 {
    color: ${Colors.yellow};
    font-size: 20px;
    margin: 0 0 8px 0;
  }

  & p {
    color: ${Colors.gold};
    font-size: 14px;
    line-height: 1.5;
    margin: 0 0 16px 0;
  }

  & .email-row {
    display: flex;
    gap: 8px;
    align-items: baseline;
    margin-bottom: 14px;
    font-size: 13px;
    color: ${Colors.textSecondary};
  }

  & .email-row strong {
    color: ${Colors.white};
  }

  & input[type='password'],
  & input[type='tel'] {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 14px;
    margin-bottom: 10px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid ${Colors.gold};
    border-radius: 6px;
    color: ${Colors.white};
    font-size: 15px;
    min-height: 46px;

    &:focus {
      outline: none;
      border-color: ${Colors.yellow};
    }

    &::placeholder {
      color: rgba(255, 215, 0, 0.5);
    }
  }

  & .error {
    margin-top: 10px;
    padding: 10px 12px;
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid #ef4444;
    color: #ef4444;
    border-radius: 6px;
    font-size: 13px;
  }

  & .actions {
    display: flex;
    gap: 10px;
    margin-top: 16px;
    flex-wrap: wrap;

    & button {
      flex: 1;
      min-width: 140px;
      padding: 12px 18px;
      border: none;
      border-radius: 6px;
      font-weight: 700;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      cursor: pointer;
      transition: transform 0.2s ease;
    }

    & button.primary {
      background: ${Colors.yellow};
      color: ${Colors.dark};
    }

    & button.secondary {
      background: transparent;
      color: ${Colors.yellow};
      border: 2px solid ${Colors.yellow};
    }

    & button:hover:not(:disabled) {
      transform: translateY(-1px);
    }

    & button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
